var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Cascader',{attrs:{"data":_vm.counties,"value":_vm.value1,"clearable":"","placeholder":"请选择地区","change-on-select":""},on:{"on-change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }